module.exports = __webpack_public_path__ + "static/media/agriculture-cultivate-garden-svgrepo-com.d461eddf.svg";